module.exports = __webpack_public_path__ + "static/media/delete-kn.0244a8f7.svg";